import { TagItem } from "@core/models/models/title-tag.model";

import { BathDais } from "@core/models/models/bathe.model";

export class StringHelper {
     /**
      * Checks whether the calculated length of an input string does not exceed a given maximum length.
      * The length is calculated based on specific Unicode ranges:
      * - ASCII characters and certain symbols count as 1.
      * - Full-width or other non-ASCII characters count as 2.
      *
      * @param maxlength - The maximum allowed length for the input.
      * @param input - The input string to validate.
      * @returns `true` if the calculated length is within the allowed range, otherwise `false`.
      */
     public static isInputLengthValid(maxlength: number, input: string | undefined): boolean {
     if (!input) return true; // If input is undefined or empty, consider it valid.

     let len = 0; // Initialize calculated length.

     for (const char of input) {
          const code = char.charCodeAt(0); // Get Unicode code of the character.

          // Define length based on character's Unicode range.
          if (
               (code >= 0x0 && code < 0x81) || // ASCII range.
               code === 0xf8f0 || // Specific control character.
               (code >= 0xff61 && code < 0xffa0) || // Half-width Katakana.
               (code >= 0xf8f1 && code < 0xf8f4) // Additional specific characters.
          ) {
               len += 1; // Count as 1.
          } else {
               len += 2; // Count as 2 for full-width or others.
          }

          // Early exit if length exceeds maximum.
          if (len > maxlength) {
               return false;
          }
     }

     return len <= maxlength; // Validate final length.
     }

     public static normalize = (value?: string | null): string =>(value ?? '').trim();

     public static isSameTag = (a?: TagItem, b?: TagItem): boolean => {
          if (!a || !b) return false;

          const n = (v?: string | null) => (v ?? '').trim(); //prevent null and trim it

          return n(a.kbnTtlTag) === n(b.kbnTtlTag)
               && n(a.iTag)?.replace("#","") === n(b.iTag)?.replace("#","");
     };
}